export default "__VITE_ASSET__88f971bb__"